module.exports = __webpack_public_path__ + "bcfa630211e2566a1873fd13dc9a688a.svg";